<div id="{{cmsgFieldId}}" class="pageMessage info userHasNotSeenMessage" *ngIf="!cmnHidden" tabindex="0" (keydown.Tab)="onTabKey($event)">
	<span class="glyphicon glyphicon-info-sign" aria-hidden="true"></span>
	<span class="sr-only" [innerHTML]="iconText"></span>
	<span>
		<ng-content></ng-content>
	</span>
	<cmn-help class="btnHelp" [cmnFieldId]="cmsgFieldId" [cmnLinkText]="cmsgLinkText" [cmnHelpFile]="cmsgHelpFile" [cmnHelpUseLocalFile]="cmsgHelpUseLocalFile" [cmnHelpLocalFilePath]="cmsgHelpLocalFilePath" *ngIf="cmsgShowHelp"></cmn-help>
</div>